import { createBulkDateUpdateValuesByGridIdSelector } from 'selectors/gridSelectors'
import { GridId } from 'store/grid'
import { useParametricSelector } from 'utils'

const bulkUpdateValuesSelector = createBulkDateUpdateValuesByGridIdSelector((_state: {}, gridId: GridId) => gridId)
export const useBulkDateUpdateValues = (gridId: GridId) => useParametricSelector(bulkUpdateValuesSelector, gridId)
